import { EConditionType } from '../../../../json_query';
import { IManufactureConditionsTag } from '../../../state/tags/definitions/manufacture_condition';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const manufactureConditionMap = {
  [EConditionType.RegularRepair]: 'Типовой ремонт',
  [EConditionType.MajorRepairNeeded]: 'Требуется капитальный ремонт',
  [EConditionType.CosmeticRepairNeeded]: 'Требуется косметический ремонт',
};

export const ManufactureConditionTypesTagItem = getMultiSelectionParamTagItem<
  EConditionType,
  IManufactureConditionsTag
>(manufactureConditionMap);
